export const getFormatEmployeeDateUtil = (variables,) => ({
	...variables,
})
